import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_mobile-footer_desktopapp_modalandroid_scan_qr_code_tab-click';
/**
 * Click on “Scan QR Code” tab (Android)
 */
export function trackRetailerMobileFooterDesktopappModalandroidScanQrCodeTabClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
